import React from 'react'
import CommonTablePage, { CommonTablePagePropsInterface } from '../../components/common/common-table/common-table-page'
import { urlKey } from '../../services/api/api-urls'
import ExceptionalLogColumnModel from './exceptional-log-column-model'
import { useDocumentTitle } from '../../services/title/useDocumentTitle'

const ExceptionalLogPage: any = (props: any) => {
  useDocumentTitle()

  const commonTablePageProps: CommonTablePagePropsInterface = {
    urlInfoKey: urlKey.ExceptionalLog,
    title: props.title || 'Irregular record',
    column: ExceptionalLogColumnModel(),
    isNotDeletable: true,
    isNotEditable: true,
    isNotAddable: true,
    mappingRenderData: (data: any[]) =>
      [...(data || [])].sort((a, b) => {
        const dateA = a.createAt ? new Date(a.createAt).getTime() : 0
        const dateB = b.createAt ? new Date(b.createAt).getTime() : 0
        return dateB - dateA
      }),
  }

  return (
    <div>
      <CommonTablePage {...commonTablePageProps} />
    </div>
  )
}

export default ExceptionalLogPage
